export async function callGroq(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  try {
    const res = await fetch('https://api.groq.com/openai/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      signal,
      body: JSON.stringify({
        model: context.modelOverride || 'llama-3.3-70b-versatile',
        messages: [
          { 
            role: 'system',
            content: context.systemPrompt || `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}.` 
          },
          { role: 'user', content: input }
        ],
        temperature: 0.2,
        max_tokens: 512
      })
    });
    
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error?.message || `Groq API error: ${res.status}`);
    }

    const data = await res.json();
    return data.choices?.[0]?.message?.content || '';
  } catch (error: any) {
    console.error('[Groq Provider] Error:', error);
    throw error;
  }
}
